module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/th_kyushu-53ba3cb00f5f21c097fc8bf9df023742.jpg";